import styled, { createGlobalStyle } from 'styled-components';
import { theme } from '@silverrailtech/srtlibrary';

export const BookingHeader = styled.div`
	padding: 16px;
	margin-top: 16px;
	border-radius: 6px;
	background-color: ${theme.colors.base.containerFill.primary};
	box-shadow: 0px 0px 4px rgba(51, 153, 255, 0.5);
	border: 1px solid #dce2e6;
`;

export const FlexWrapper = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
`;

export const BookingTabWrapper = styled.div`
	background-color: ${theme.colors.base.containerFill.strong};
	padding: 10px 0;
	margin-bottom: 16px;
`;

export const PaginationWrapper = styled.div`
	padding: 8px 0;
`;

export const BookingTab = styled.div`
	display: flex;
	gap: 10px;
`;

export const BookingCreateWrapper = styled.div`
	display: flex;
	justify-content: flex-end;
	padding: 16px;
`;
export const AccountDetailsWrapper = styled.div`
	margin: 16px 0 30px 0;
	.MuiFormControl-root.MuiTextField-root {
		margin-top: 0 !important;
	}
`;
export const SmartCardWrapper = styled.div`
	// This avoids the need for important
	&& {
		div:first-of-type {
			section {
				form {
					div:nth-of-type(2) {
						.custom-smartcard-adornment {
							margin-top: 0;
						}
					}
				}
			}
		}
	}
`;

export const GlobalEVoucherStyle = createGlobalStyle`
	.MuiFormControl-root.MuiTextField-root {
		margin-top: 0 !important;
	}
`;
